import React from "react";
import "./education.css";
import IITLOGO from "../../assests/images/iitb.png";
import SSjainLOGO from "../../assests/images/ssjain.jpg";
import { competitiveSites } from "../../data";

const schools = [
  {
    logo: IITLOGO,
    alt: "IIT Bombay",
    name: "Indian Institute of Technology Bombay (IIT Bombay)",
    detail: "MSc in Physics · CGPA 7.56",
    time: "2021 – 2023",
  },
  {
    logo: SSjainLOGO,
    alt: "University of Rajasthan",
    name: "S. S. Jain Subodh College, University of Rajasthan",
    detail: "BSc in Physics (Honours) · 80%",
    time: "2018 – 2021",
  },
];

export default function Education() {
  return (
    <section className="section" id="education">
      <div className="section-inner">
        <h2 className="section-title">Education</h2>
        <span className="section-title-accent" />

        <div className="edu-grid">
          {schools.map((s) => (
            <div className="edu-card" key={s.name}>
              <img className="edu-logo" src={s.logo} alt={s.alt} />
              <div className="edu-body">
                <h3 className="edu-name">{s.name}</h3>
                <p className="edu-detail">{s.detail}</p>
                <span className="edu-time">{s.time}</span>
              </div>
            </div>
          ))}
        </div>

        <h3 className="edu-links-title">Find me online</h3>
        <div className="edu-links">
          {competitiveSites["competitiveSites"].map((data, id) => (
            <a
              key={id}
              href={data.profileLink}
              target="_blank"
              rel="noopener noreferrer"
              className="edu-link"
            >
              {data.siteName}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
